'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('../../../../atoms/button/jsx/Button');

var _Button2 = _interopRequireDefault(_Button);

var _MPPSubnav = require('./MPPSubnav');

var _MPPSubnav2 = _interopRequireDefault(_MPPSubnav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MainMenu = function (_Component) {
  _inherits(MainMenu, _Component);

  function MainMenu(props) {
    _classCallCheck(this, MainMenu);

    var _this = _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).call(this, props));

    _this.render = _this.render.bind(_this);
    _this.renderByStrategies = _this.renderByStrategies.bind(_this);
    return _this;
  }

  _createClass(MainMenu, [{
    key: 'renderByStrategies',
    value: function renderByStrategies(elem, idx, handlers) {
      var _props = this.props,
          register = _props.register,
          activeLinkIndex = _props.activeLinkIndex,
          closingLinkIndex = _props.closingLinkIndex;
      var minimalHeader = this.props.content.minimalHeader;

      var strategies = {
        link: function link(elementContent) {
          return _react2.default.createElement(
            'li',
            { key: 'sublist-link' + idx },
            _react2.default.createElement(
              'a',
              {
                href: elementContent.href,
                className: 'sublist-link',
                'data-pa-click': 'HeaderSublist-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        cta: function cta(elementContent) {
          return _react2.default.createElement(
            'li',
            { className: 'sublist-cta-wrapper', key: 'sublist-link' + idx },
            _react2.default.createElement(
              _Button2.default,
              {
                href: elementContent.href,
                className: 'sublist-cta',
                color: 'outline-white',
                fpti: 'HeaderMainMenu-Cta-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        linkOnly: function linkOnly(elementContent) {
          var highlighClassName = '';
          if (typeof window !== 'undefined') {
            var currentLocation = window.location.pathname;
            if (currentLocation.indexOf(elementContent.href) !== -1) {
              highlighClassName = 'pypl-header__subnav-control--is-highlighted';
            }
          }
          var linkClass = (0, _classnames2.default)('main-link', highlighClassName, elementContent.className);
          return _react2.default.createElement(
            'li',
            { key: 'main-link' + idx },
            _react2.default.createElement(
              'a',
              {
                id: elementContent.id,
                href: elementContent.href,
                className: linkClass,
                'data-pa-click': 'HeaderMainMenu-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        languageDesk: function languageDesk(elementContent) {
          return _react2.default.createElement(
            'li',
            { key: 'main-link' + idx, className: 'hidden-lg-down' },
            _react2.default.createElement(
              'a',
              {
                id: elementContent.id,
                href: elementContent.href,
                className: 'main-link separator-menu',
                'data-pa-click': 'HeaderMainMenu-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        languageMobile: function languageMobile(elementContent) {
          return _react2.default.createElement(
            'li',
            { key: 'main-link' + idx, className: 'hidden-xl-up' },
            _react2.default.createElement(
              'a',
              {
                id: elementContent.id,
                href: elementContent.href,
                className: 'main-link',
                'data-pa-click': 'HeaderMainMenu-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        linkOnlyDesk: function linkOnlyDesk(elementContent) {
          return _react2.default.createElement(
            'li',
            { className: 'hidden-lg-down', key: 'main-link' + idx },
            _react2.default.createElement(
              'a',
              {
                id: elementContent.id,
                href: elementContent.href,
                className: 'main-link',
                'data-pa-click': 'HeaderMainMenu-Link-' + elementContent.text
              },
              elementContent.text
            )
          );
        },
        subnav: function subnav(elementContent) {
          return _react2.default.createElement(_MPPSubnav2.default, {
            key: 'main-link' + idx,
            content: elementContent,
            handlers: handlers,
            minimalHeader: minimalHeader,
            register: register,
            activeLinkIndex: activeLinkIndex,
            closingLinkIndex: closingLinkIndex
          });
        },
        subnavGrouped: function subnavGrouped(elementContent) {
          return _react2.default.createElement(_MPPSubnav2.default, {
            key: 'main-link' + idx,
            content: elementContent,
            handlers: handlers,
            minimalHeader: minimalHeader,
            register: register,
            activeLinkIndex: activeLinkIndex,
            closingLinkIndex: closingLinkIndex,
            grouped: true
          });
        }
      };
      return strategies[elem.type](elem);
    }
  }, {
    key: 'renderMainMenuLinks',
    value: function renderMainMenuLinks(mainMenuContent) {
      var _this2 = this;

      return mainMenuContent.map(function (elem, idx) {
        return _this2.renderByStrategies(elem, idx, _this2.props.handlers);
      });
    }
  }, {
    key: 'renderSublistLinks',
    value: function renderSublistLinks(sublistMobile) {
      var _this3 = this;

      return sublistMobile.map(function (elem, idx) {
        return _this3.renderByStrategies(elem, idx, _this3.props.handlers);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$content = this.props.content,
          mainMenuContent = _props$content.mainMenuContent,
          sublistMobile = _props$content.sublistMobile;

      return _react2.default.createElement(
        'nav',
        { id: 'main-menu', className: 'main-menu' },
        _react2.default.createElement(
          'ul',
          { className: 'main-menu-list' },
          this.renderMainMenuLinks(mainMenuContent)
        ),
        _react2.default.createElement(
          'ul',
          { className: 'main-menu__sublist' },
          this.renderSublistLinks(sublistMobile)
        )
      );
    }
  }]);

  return MainMenu;
}(_react.Component);

MainMenu.propTypes = {
  content: _propTypes2.default.object.isRequired,
  register: _propTypes2.default.func.isRequired,
  handlers: _propTypes2.default.object.isRequired,
  activeLinkIndex: _propTypes2.default.number.isRequired,
  closingLinkIndex: _propTypes2.default.number
};

MainMenu.defaultProps = {
  closingLinkIndex: 0
};

exports.default = MainMenu;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/components/MPPMainMenu.js
// module id = 683
// module chunks = 4